export default "__VITE_ASSET__03f1bc89__"